import { CommonModule } from '@angular/common';
import { Component, Directive, NgModule } from '@angular/core';
import { Button, ButtonDirective } from 'primeng/button';

@Directive({
  selector: '[rfButton]',
  standalone: false,
})
export class RfButtonDirective extends ButtonDirective {}

@Component({
  selector: 'rf-button',
  templateUrl: './button.html',
  standalone: false,
})
export class RfButtonComponent extends Button {}

@NgModule({
  imports: [CommonModule],
  exports: [RfButtonDirective, RfButtonComponent],
  declarations: [RfButtonDirective, RfButtonComponent],
})
export class RfButtonModule {}
